import { useCallback, useState, useLayoutEffect, useMemo } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "../header/FilterReport"
import styles from "../style.module.css"
import { format, startOfMonth, endOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service";
import _ from "lodash"
import { Spin, Tabs } from "antd"
import "../scss/report.scss"
import StorageService from "../../../utils/storage.service";
import ReportCashFlowDefault from "./ReportCashFlowDefault";
import ReportCashFlowUpsale from "./ReportCashFlowUpsale";
import ReportChuyenDoiCoc from "./ReportChuyenDoiCoc";
import ReportConvertPackage from "./ReportConvertPackage"
import ReportUpgradePackage from "./ReportUpgradePackage"
import ReportNapTien from "./ReportNapTien";

const ReportCashFlow = () => {
    var date = new Date();
    // date.setDate(date.getDate() - 1);
    let month = date.getMonth()
    let year = date.getFullYear()
    if (date.getMonth() == 0) {
        month = 12
        year = year - 1
    }
    let oldMonth = year + '-' + month + '-'
    let day = date.getDate()
    let endOfMonth1 = new Date(endOfMonth(new Date(date)))
    let endOfMonthOld = new Date(endOfMonth(new Date(oldMonth + day)))
    if (day == endOfMonth1.getDate()) {
        day = endOfMonthOld.getDate()
    }

    let olDate = new Date(oldMonth + day)
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(date)),"yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(date), 'yyyy-MM-dd'))
    const [startOldDate, setStartOldDate] = useState(format(new Date(startOfMonth(olDate)),"yyyy-MM-dd"))
    const [endOldDate, setEndOldDate] = useState(format(new Date(olDate), 'yyyy-MM-dd'))

    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [sortBy, setSortBy] = useState(0)
    const [loading, setLoading] = useState(true);
    const [isExport, setIsExport] = useState(false)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [pageSize, setPageSize] = useState(5)
    const [selectUser, setSelectUser] = useState('')

    const [rows, setRows] = useState([])
    const [tableUpgrade, setTableUpgrade] = useState([])
    const [tableChuyenDoi, setTableChuyenDoi] = useState([])
    const [tableUpsale, setTableUpsale] = useState([])
    const [tableNapTien, setTableNapTien] = useState([])
    const [tableConvertPackage, setTableConvertPackage] = useState([])

    const handleRangeDate = useCallback((sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
        handleOleDate(sDate, eDate)
    }, [startDate, endDate])

    const handleStore = useCallback((e) => {
        setStore(e)
    }, [store])
    
    const handleRangeDateOld = useCallback((sDate, eDate) => {
        setStartOldDate(sDate)
        setEndOldDate(eDate)
       
    }, [startOldDate, endOldDate])

    const handleOleDate = async (start, end) => {
        start = new Date(start)
        end = new Date(end)
        let oldMonth = start.getFullYear() + '-' + start.getMonth() + '-'
        let olDate = format(new Date(startOfMonth(new Date(oldMonth + start.getDate()))), 'yyyy-MM-dd' )
        let olEndDate = format(new Date(new Date(oldMonth + end.getDate())), 'yyyy-MM-dd' )
        setStartOldDate(olDate)
        setEndOldDate(olEndDate)
    }

    const handleSortBy = useCallback((e) => {
        setSortBy(e)
    }, [sortBy]);

    useLayoutEffect(() => {
        setLoading(true)
        fetchData(store, endDate, startDate, sortBy, startOldDate, endOldDate)
    }, [store, endDate, startDate, sortBy, startOldDate, endOldDate, selectUser])
    
    const fetchData = async (s, eD, sD, sBy, startOldDate, endOldDate) => {
        const rs = await axiosService(`api/reports-view/customer-paid-store?storeId=${s}&startDate=${sD}&endDate=${eD}&startOldDate=${startOldDate}&endOldDate=${endOldDate}&sortBy=${sBy}&selectUser=${selectUser}`, "GET")
        const { anotherPayment, upsaleAnother, upgradePackage, convertDeposit, convertPackage, orderDeposit} = rs.data.data
        if (rs.status == 200) {
            setRows(_.map(anotherPayment, (item, index) => ({...item, id: index + 1,})))
            setTableUpsale(_.map(upsaleAnother, (item, index) => ({...item, id: index + 1,})))
            setTableUpgrade(_.map(upgradePackage, (item, index) => ({...item, id: index + 1,})))
            setTableChuyenDoi(_.map(convertDeposit, (item, index) => ({...item, id: index + 1,})))
            setTableConvertPackage(_.map(convertPackage, (item, index) => ({...item, id: index + 1,})))
            setTableNapTien(_.map(orderDeposit, (item, index) => ({...item, id: index + 1,})))
            setLoading(false)
        }
    }

    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    const selectListUser = (e) => {
        setSelectUser(e.toString())
    }

    const tabItems = [
        {
            key: '1',
            label: 'Thu hộ',
            children: (
                <ReportCashFlowDefault
                    table={rows}
                    startDate={startDate}
                    endDate={endDate}
                    store={store}
                />
            ),
        },
        {
            key: '2',
            label: 'Upsale',
            children: (
                <ReportCashFlowUpsale
                    table={tableUpsale}
                    startDate={startDate}
                    endDate={endDate}
                    store={store}
                />
            ),
        },
        {
            key: '3',
            label: 'Nâng cấp thẻ',
            children: (
                <ReportUpgradePackage
                    table={tableUpgrade}
                    startDate={startDate}
                    endDate={endDate}
                    store={store}
                />
            ),
        },
        {
            key: '4',
            label: 'Chuyển đổi đơn hàng',
            children: (
                <ReportChuyenDoiCoc
                    table={tableChuyenDoi}
                    startDate={startDate}
                    endDate={endDate}
                    store={store}
                />
            ),
        },
        {
            key: '5',
            label: 'Chuyển đổi thẻ',
            children: (
                <ReportConvertPackage
                    table={tableConvertPackage}
                    startDate={startDate}
                    endDate={endDate}
                    store={store}
                />
            ),
        },
        {
            key: '6',
            label: 'Nạp tiền',
            children: (
                <ReportNapTien
                    table={tableNapTien}
                    startDate={startDate}
                    endDate={endDate}
                    store={store}
                />
            ),
        },

    ];
    return (
        <div className={`${styles.background} report-page container-fluid`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                sortBy={sortBy} handleSortBy={handleSortBy}
                title={"Dòng tiền chéo"} type={"cash-flow"}
                csvData={rows} isExport={isExport}
                handleExportData={handleExportData}
                header={
                    [
                        { label: 'Thời gian', key: "date" },
                        { label: "Số lượng lịch đặt", key: "count_booking" },
                        { label: "Số lượng lịch huỷ", key: "count_close" },
                        { label: "Số lượng lịch thành công", key: "count_success" },
                        { label: "Tỉ lệ huỷ/tổng lịch đặt", key: "proportion" },
                        { label: "Số lượng khách hàng phục vụ", key: "count_customer" },
                        { label: "Lượt dịch vụ", key: "count_service" },
                    ]
                }
                userAdmin={userAdmin}
                startOldDate={startOldDate} endOldDate={endOldDate}
                handleRangeDateOld={handleRangeDateOld}
                selectListUser = {selectListUser}
            />
            <Spin spinning={loading}>
                <Row className="mt-2" style={{alignItems: 'end'}}>
                    <Col xs={12} md={12}>
                        <div className="p-2" style={{ backgroundColor: "white" }} >
                            <Tabs defaultActiveKey="1" items={tabItems} />
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div >
    )
}

export default ReportCashFlow
